/* External */
import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';

function VirtualizedItem({
  index,
  position,
  height: rowHeight = undefined,
  renderer: Renderer,
  firstVisibleElementIndex,
}) {
  const style = useMemo(() => ({
    position: 'absolute',
    boxSizing: 'border-box',
    width: '100%',
    top: `${position}px`,
    height: typeof rowHeight === 'number' && rowHeight > 0 ? `${rowHeight}px` : undefined,
    minHeight: typeof rowHeight === 'number' && rowHeight > 0 ? `${rowHeight}px` : undefined,
    willChange: 'transform',
  }), [position, rowHeight]);

  return (
    <div style={style}>
      <Renderer index={index} firstVisibleElementIndex={firstVisibleElementIndex} />
    </div>
  );
}

VirtualizedItem.propTypes = {
  index: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  height: PropTypes.number,
  renderer: PropTypes.elementType.isRequired,
  firstVisibleElementIndex: PropTypes.number.isRequired,
};

export default memo(VirtualizedItem);
